module.exports = __webpack_public_path__ + "img/phone.f9284157.svg";